import { isMobile, isIOS, isAndroid, isTablet } from "react-device-detect";

class GBETNativeInterface {

    static isSafariOrUIWebView = (/(iPhone|iPod|iPad)[\w\W]*AppleWebKit/i).test(navigator.userAgent);

    // WKWebView is the native container used in the latest BETDAQ & Ladbrokes iOS app's, replacing deprecated UIWebView
    static isWKWebView = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.javaScriptToSwift;

    //Exch/SB app
    static isWKWebViewWithSportsbookLink = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goToSportsbook;

    static isUIWebView = (/(iPhone|iPod|iPad|Macintosh)[\w\W]*AppleWebKit(?![\w\W]*Safari)/i).test(navigator.userAgent);

    //old ios
    static isAndroidWebView = (/(Android)/i).test(navigator.userAgent) && (/(BETDAQ)/i).test(navigator.userAgent);

    static androidWebViewSupportsBiometricAuthentication = true;

    static getClientIdentifier = function () {
        let channel = "D";
        if (isMobile || isTablet) {
            var deviceType = isTablet ? "T" : "M";
            if (isIOS) {
                if (GBETNativeInterface.isWKWebView) {
                    channel = deviceType + "~IOS~App";

                } else {
                    channel = deviceType + "~IOS~Browser";
                }

            } else if (isAndroid) {
                if (GBETNativeInterface.isAndroidWebView) {
                    channel = deviceType + "~Android~App";

                } else {
                    channel = deviceType + "~Android~Browser";
                }
            }
        } else {
            if (isIOS) {
                channel = "D~IOS~Browser";
            } else {
                channel = "D~Windows~Browser";
            }
        }

        return channel;

    };

    static clientIdentifier = GBETNativeInterface.getClientIdentifier();


    static GBETNativeInterface() {

    }

}

export default GBETNativeInterface;